var config = {
//    bizName: "default",
    timeout: 10000,
    source: '',
    enables: [],
    disables: [],
    urlParamNames: ["latitude", "longitude"],
    cacheType: "cookie", //storage , false不缓存
    cookieNames: ["locallat", "locallng", "localcity"],
    storageName: "whereami",
    wxAutoConfig: false,
    useTecentGeo: false,
    city:false,     //是否要获取City信息
    debug: false,
    sampling: 0.5
};


exports.get = function (key) {
    return config[key];
};

exports.set = function (key, value) {
    config[key] = value;
};

exports.config = function (obj) {
    Object.keys(obj).forEach(function (key) {
        config[key] = obj[key];
    });
};


// WEBPACK FOOTER //
// ./~/@dp/whereami/lib/config.js